;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .constant('VSTS_UNASSIGNED', {
      display_name: 'Unassigned',
      unique_name: 'Unassigned',
      id: -1
    })
    .constant('VSTS_VERSIONS', [
      { value: 'VSTS', name: 'Azure DevOps Services / VSTS' },
      { value: 'TFS_2017', name: 'TFS 2017' },
      { value: 'TFS_2015', name: 'TFS 2015' }
    ])
    .constant('VSTS_BASIC_AUTH_VERSIONS', ['TFS_2015'])
    .constant('VSTS_DEFAULT_VERSION', 'VSTS')
    .constant('VSTS_PRIORITIES', {
      CRITICAL: 'CRITICAL',
      HIGH: 'HIGH',
      MEDIUM: 'MEDIUM',
      LOW: 'LOW',
      NOTE: 'NOTE'
    })
})()
